<ng-container *ngIf="userService.user$ | async as cUser">
    <mat-form-field appearance="fill">
        <mat-select [formControl]="fGroup.get('internal_country')">
            <mat-option *ngFor="let country of countries"
                        [value]="country.abbreviation">
                <div class="w-full flex flex-row">
                    <div>
                        <img class="h-10"
                             [src]="'assets/images/flags/' + country.abbreviation?.toUpperCase() + '.svg'"
                             [alt]="'Flag image for ' + country.country"
                        >
                    </div>
                    <div class="ml-1">{{country.country | translateLabel:curLang}}</div>
                </div>

            </mat-option>
        </mat-select>
        <mat-error
                *ngIf="fGroup.get('internal_country').hasError('required')">{{'Vous devez choisir un pays'|transloco}}</mat-error>
    </mat-form-field>

    <div *ngIf="fGroup.get('internal_country').value" class="flex flex-col" style="max-height: 320px;overflow-y: auto;">
        <button *ngFor="let aState of states[fGroup.get('internal_country').value]"
                mat-raised-button
                class="mb-2 w-full whitespace-pre-wrap ext-profile-choice-btn"
                [ngClass]="{'text-white	bg-green-inbe': cUser?.extProfiles?.['etat_province_usa_canada']===fGroup.get('internal_country').value + '-' + aState.abbreviation }"
                (click)="chooseState(fGroup.get('internal_country').value, aState.abbreviation)"
        >
            ({{aState.abbreviation}}) - {{aState.name | translateLabel:curLang}}
        </button>
    </div>
</ng-container>
